import React from 'react';

// The glyphs for the Share and Save buttons and their pop-ups, drawn to the
// listing page design (24px grid, 1.75 stroke). They stroke and fill with
// currentColor unless a colour is given, so each button's CSS decides it.

const Svg = ({ className, children, strokeWidth = 1.75, fill = 'none' }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill={fill}
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

const HEART_PATH =
  'M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2z';

/** Outline when not saved, filled when saved. */
export const HeartIcon = ({ className, filled }) => (
  <Svg className={className} fill={filled ? 'currentColor' : 'none'}>
    <path d={HEART_PATH} />
  </Svg>
);

/** A box with an arrow leaving it — the usual "share" mark. */
export const ShareIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M12 3v12" />
    <path d="M7.5 7.5L12 3l4.5 4.5" />
    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
  </Svg>
);

export const CheckIcon = ({ className }) => (
  <Svg className={className} strokeWidth={2}>
    <path d="M4 12.5l5 5L20 6.5" />
  </Svg>
);

export const LockIcon = ({ className }) => (
  <Svg className={className}>
    <rect x="5" y="10.5" width="14" height="10" rx="1.5" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
  </Svg>
);

export const LinkIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M10 13.5a4.5 4.5 0 0 0 6.4.4l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2" />
    <path d="M14 10.5a4.5 4.5 0 0 0-6.4-.4l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2" />
  </Svg>
);

export const CloseIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Svg>
);
